'use client';

import { useParams } from 'next/navigation';
import { useGetCompanyDetail } from '@/features/company/api/company.queries';

export function useCompanyFromRoute() {
  const params = useParams();
  const slug = String(params.slug ?? '');
  const { data, isLoading } = useGetCompanyDetail(slug);

  return {
    company: data?.data,
    isLoading,
    slug,
  };
}
